import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { 
    Tooltip,
 } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService"
import apiResponse from '../../../../../services/apiResponse'

import DataTableBloc from "../Blocs/PeriodBloc"

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear()+" "+d.getHours()+":"+d.getMinutes();
    }

    return '-'
};
class PeriodListComponent extends Component {
    dataTableBloc = new DataTableBloc();
    source
    historyTable = 'historyWorkUnitTablePeriod' // Nama di tiap tabel harus beda karena akan disimpan di session
    defaultOrder = 'work_unit_period_id' // orderBy
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: 
                    {
                        filter_value: "",
                        page_number: 1,
                        page_size: this.defaultSize,
                        sort_order: {
                            column: this.defaultOrder,
                            order: this.defaultSort
                        }
                    }
            } 
    }
    
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    componentDidMount() {

        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel?.unsubscribe()
    }

    columns = [
        {
            key: "work_unit_period_start_date",
            text: "Mulai Period",
            sortable: true,
            cell: record => {
                return reformatDate(record.work_unit_period_start_date)
            }
        },
        {
            key: "work_unit_period_end_date",
            text: "Berakhir Period",
            sortable: true,
            cell: record => {
                return reformatDate(record.work_unit_period_end_date)
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.work_unit_period_id
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"push-" + thisId}
                                onClick={() => {
                                    this.props.changeUUID(record)
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-tag-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["push" + thisId]} target={"push-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["push" + thisId] : !this.state["push" + thisId]
                                    })
                                }}
                            >Lihat Periode</Tooltip>
                        </span>
                    </Fragment>
                )
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                />
            </>
        )
    }
}

export default PeriodListComponent